import { type PrimaryCategory } from '@webapp/core/entities/internal/PrimaryCategory'
import { useQueryPrimaryCategories } from '../../models/useQueryPrimaryCategories'

interface UseFirstPrimaryCategoryPresenterReturn {
  data: {
    firstPrimaryCategory: PrimaryCategory | undefined
  }
  states: {
    isFetching: boolean
  }
}

/**
 * Provides the tenant's first PrimaryCategory so the Feature Set can
 * auto-select it on page load (BHV-002). Empty tenant → `undefined`.
 */
export const useFirstPrimaryCategoryPresenter =
  (): UseFirstPrimaryCategoryPresenterReturn => {
    const { primaryCategories, isFetching } = useQueryPrimaryCategories({
      params: { pageSize: 1, simple: true },
    })

    return {
      data: {
        firstPrimaryCategory: primaryCategories[0],
      },
      states: {
        isFetching,
      },
    }
  }
